import { Controller } from "@hotwired/stimulus";

declare var $: any;

export default class extends Controller {
  static targets = ["select"];
  declare selectTarget: HTMLSelectElement;

  connect() {
    // Defensive check: ensure multipleSelect plugin is loaded
    if (typeof $ !== 'undefined' && typeof $.fn.multipleSelect === 'function') {
      $(this.selectTarget).multipleSelect({
        allSelected: true,
        selectAll: true,
        formatAllSelected: () => 'All',
        formatSelectAll: () => 'Select All / None',
        maxHeight: '600',
        placeholder: 'State'
      });
    } else {
      console.warn('[MultipleSelectComponent] multipleSelect plugin not loaded.');
      // Fallback: component degrades gracefully to native multi-select
    }
  }
}
